import _ax from './_ax';

export function sendWithdraw(params) {
    return _ax.post('withdrawalv2', { ...params });
}
export function sendInternalWithdraw(params) {
    return _ax.post('transfer', { ...params });
}
